import { render, staticRenderFns } from "./ListeningPhonics1ForSP.vue?vue&type=template&id=5fb06124&scoped=true&"
import script from "./ListeningPhonics1ForSP.vue?vue&type=script&lang=js&"
export * from "./ListeningPhonics1ForSP.vue?vue&type=script&lang=js&"
import style0 from "./ListeningPhonics1ForSP.vue?vue&type=style&index=0&id=5fb06124&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb06124",
  null
  
)

export default component.exports